import { StampCard, Merchant } from './index';

export interface IntegrationConfiguration {
  _id?: string;
  type?: string;
  value?: number;
  sku?: string;
  card?: string | StampCard;
  numberOfStamps?: number;
  numberOfPoints?: number;
  method?: string;
  cap?: number;
  pointsRoundingMode?: 'down' | 'nearest' | 'up' | 'exact';
  notificationMessage?: string;
  notificationMessageWithReward?: string;
}

export interface IntegrationSubscription {
  _id?: string;
  event?: string;
  hookUrl?: string;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IntegrationConfig {
  merchant?: string | Merchant;
  signingKey?: string;
  subdomain?: string;
  username?: string;
  password?: string;
  addCustomers?: boolean;
  accessToken?: string;
  userId?: string;
  apiKey?: string;
  scopes?: string[];
  configurations?: IntegrationConfiguration[];
  integrationType?: string;
  inviteUser?: {
    active?: boolean;
    withStamps?: boolean;
  };
  oauth: {
    id: string;
    secret: string;
    createdOn: Date;
    updatedOn: Date;
    topics: string[];
  };
  subscriptions?: IntegrationSubscription[];
  makeSettings?: {
    awardStamps?: boolean;
    rewardAutomation?: {
      enabled?: boolean;
      type?: 'product' | 'coupon';
      couponId?: string;
      productId?: string;
    };
  };
  apiSettings?: {
    awardStamps?: boolean;
    rewardAutomation?: {
      enabled?: boolean;
      type?: 'product' | 'coupon';
      couponId?: string;
      productId?: string;
    };
  };
  zapierSettings?: {
    awardStamps?: boolean;
    rewardAutomation?: {
      enabled?: boolean;
      type?: 'product' | 'coupon';
      couponId?: string;
      productId?: string;
    };
  };
}

export type PublicApiKeyStatus = 'active' | 'expired' | 'revoked';

export interface PublicApiKey {
  _id: string;
  name: string;
  keyPrefix: string;
  lastFour: string;
  scopes: string[];
  status: PublicApiKeyStatus;
  lastUsedAt?: Date;
  expiresAt?: Date;
  revokedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface PublicApiKeyCreatedResponse {
  apiKey: PublicApiKey;
  secret: string;
}

export interface PublicApiEndpointUsage {
  method: string;
  route: string;
  requests: number;
  errors: number;
  averageDurationMs: number;
  lastRequestAt?: Date;
}

export interface PublicApiKeyUsage {
  apiKeyId: string;
  name: string;
  keyPrefix: string;
  lastFour: string;
  status: PublicApiKeyStatus;
  requests: number;
  errors: number;
  errorRate: number;
  averageDurationMs: number;
  lastRequestAt?: Date;
  endpoints: PublicApiEndpointUsage[];
}

export interface PublicApiUsageReport {
  period: { days: number; from: Date; to: Date };
  totals: {
    requests: number;
    errors: number;
    errorRate: number;
    averageDurationMs: number;
  };
  keys: PublicApiKeyUsage[];
}
